import React from 'react'
import { Link, useLocation } from 'react-router-dom'


function SocialShare() {
  const location = useLocation();
//console.log(window.location.href)


var pagepath = window.location.href
 const genericSocialShare = (url) => {  
		window.open(url+pagepath,'sharer','toolbar=0,status=0,width=648,height=395');
		return true;
	}

const copyUrl = () =>{
 //navigator.clipboard.writeText(pagepath) 
 alert(pagepath)
}



//const [text, setText] = useState("Add text you want to copy");

const handleCopyClick = async () => {
  //alert("Copied to clipboard!");
  try {
      await navigator.clipboard.writeText(window.location.href);
      alert("Copied to clipboard!");
  } catch (err) {
      console.error(
          "Unable to copy to clipboard.",
          err
      );
      alert("Copy to clipboard failed.");
  }
};





  return (
<div className="social-share-icon"> <span>Share <i className="fa fa-share-alt" aria-hidden="true"></i></span>
  <ul>
    <li><Link to="javascript:void(0)" className="icon-fb" onClick={()=>{genericSocialShare(`http://www.facebook.com/sharer.php?u=`) }} title="Facebook Share"><i className="fa-brands fa-facebook"></i></Link> </li>
    <li><Link to="javascript:void(0)" className="icon-twitter" onClick={()=>{genericSocialShare(`https://twitter.com/intent/tweet?url=`) }} title="Twitter Share"><i className="fa-brands fa-x-twitter"></i></Link> </li>   
    <li><Link to="javascript:void(0)" className="icon-linkdin" onClick={()=>{genericSocialShare(`https://api.whatsapp.com/send?text=`) }} title="Whatsapp Share"><i className="fa-brands fa-whatsapp"></i></Link> </li>
    <li><Link to="javascript:void(0)" className="icon-linkdin" onClick={()=>{genericSocialShare(`https://pinterest.com/pin/create/button/?url=`) }} title="Pinterest Share"><i className="fa-brands fa-pinterest"></i></Link> </li>
    <li><Link to={`mailto:?body=${pagepath}`} className="icon-linkdin" title="Email"><i className="fa-solid fa-envelope"></i></Link> </li>
    <li><Link id="copyItem" to="javascript:void(0)" className="icon-linkdin" onClick={handleCopyClick} title="Copy"><i className="fa fa-clipboard" aria-hidden="true"></i></Link> </li>
  </ul>
</div>
  )
}

export default SocialShare
